// MobileBasketFab — the design's `.basket-fab`: a dark floating pill with an
// azurite shopping-bag tile + count, "Request access / N items ready", and an
// up-chevron. Shown bottom-right of the catalog sheet once the basket has
// items; tapping it advances to the configure step.

import { Box, Icon } from "@chakra-ui/react";
import { keyframes } from "@emotion/react";
import { TbChevronUp, TbShoppingBag } from "react-icons/tb";

// Pop in from slightly down + scaled (never from scale(0) — Emil rule).
const pop = keyframes`
  from { opacity: 0; transform: translateY(12px) scale(0.92); }
  to   { opacity: 1; transform: translateY(0) scale(1); }
`;

const MobileBasketFab = ({
  count,
  onClick,
}: {
  count: number;
  onClick: () => void;
}) => (
  <Box
    as="button"
    type="button"
    onClick={onClick}
    display="inline-flex"
    alignItems="center"
    gap="10px"
    pl="8px"
    pr="14px"
    py="8px"
    bg="neutral.1000"
    color="white"
    border="1px solid"
    borderColor="rgba(255,255,255,0.08)"
    borderRadius="component.2xl" // 12px
    boxShadow="0 4px 8px rgba(16,24,40,0.20), 0 12px 24px rgba(16,24,40,0.25), inset 0 1px 0 rgba(255,255,255,0.10)"
    transition="background 120ms, transform 80ms"
    _hover={{ bg: "neutral.950" }}
    _active={{ transform: "translateY(1px)" }}
    animation={`${pop} 320ms cubic-bezier(0.2, 0.7, 0.2, 1.1)`}
    sx={{ "@media (prefers-reduced-motion: reduce)": { animation: "none !important" } }}
  >
    <Box
      position="relative"
      w="32px"
      h="32px"
      bg="azurite.500"
      borderRadius="component.lg" // 8px
      display="inline-flex"
      alignItems="center"
      justifyContent="center"
      flexShrink={0}
    >
      <Icon as={TbShoppingBag} boxSize="18px" color="white" />
      <Box
        position="absolute"
        top="-4px"
        right="-4px"
        minW="18px"
        h="18px"
        px="5px"
        bg="white"
        color="neutral.950"
        fontSize="11px"
        fontWeight={700}
        borderRadius="full"
        display="inline-flex"
        alignItems="center"
        justifyContent="center"
        border="2px solid"
        borderColor="neutral.1000"
        sx={{ fontVariantNumeric: "tabular-nums" }}
      >
        {count}
      </Box>
    </Box>
    <Box
      display="flex"
      flexDirection="column"
      gap="1px"
      lineHeight="1.1"
      textAlign="left"
    >
      <Box fontSize="13px" fontWeight={600}>
        Request access
      </Box>
      <Box fontSize="11px" fontWeight={500} color="rgba(255,255,255,0.65)">
        {count} {count === 1 ? "item" : "items"} ready
      </Box>
    </Box>
    <Icon
      as={TbChevronUp}
      boxSize="14px"
      color="rgba(255,255,255,0.6)"
      flexShrink={0}
    />
  </Box>
);

export default MobileBasketFab;
